var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardBullet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    fill: "none",
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC100",
    fillRule: "evenodd",
    d: "M2.16667 0H5.5C6.41917 0 7.16667 0.7475 7.16667 1.66667V5C7.16667 5.91917 6.41917 6.66667 5.5 6.66667H2.16667C1.2475 6.66667 0.5 5.91917 0.5 5V1.66667C0.5 0.7475 1.2475 0 2.16667 0ZM10.5 0H13.8333C14.7525 0 15.5 0.7475 15.5 1.66667V5C15.5 5.91917 14.7525 6.66667 13.8333 6.66667H10.5C9.58083 6.66667 8.83333 5.91917 8.83333 5V1.66667C8.83333 0.7475 9.58083 0 10.5 0ZM5.5 8.33333H2.16667C1.2475 8.33333 0.5 9.08083 0.5 10V13.3333C0.5 14.2525 1.2475 15 2.16667 15H5.5C6.41917 15 7.16667 14.2525 7.16667 13.3333V10C7.16667 9.08083 6.41917 8.33333 5.5 8.33333ZM10.5 8.33333H13.8333C14.7525 8.33333 15.5 9.08083 15.5 10V13.3333C15.5 14.2525 14.7525 15 13.8333 15H10.5C9.58083 15 8.83333 14.2525 8.83333 13.3333V10C8.83333 9.08083 9.58083 8.33333 10.5 8.33333Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBullet);
export default __webpack_public_path__ + "static/media/DashboardBullet.9ce38c3b.svg";
export { ForwardRef as ReactComponent };